<template>
  <router-view></router-view>
</template>

<script>
import Home from './pages/home/index.vue'
import Clause from './pages/clause/index.vue'

export default {
  name: 'App',
  components: {
    Home,
    Clause
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  /* background-color: #161617; */
  background-color: rgb(245, 245, 247);
  margin: 0;
  padding: 10px;
}
.page-container {
  background-color: rgb(245, 245, 247);
  width: 100%;
  height: 100%;
  overflow: scroll;
}

/* 修改elem-ui */
.el-tabs__header {
  margin: 0px!important;
}
.el-tabs__nav-wrap{
  background-color: rgba(0, 0, 0, .8)!important;
}
.el-tabs__nav-wrap::after {
  background-color: rgba(0, 0, 0, .8)!important;
}
.el-tabs__item.is-active {
  color: #fff!important;
  font-weight: bold;
}
.el-tabs__item.is-top {
  color: #E8E8ED!important;
}
.el-tabs__active-bar {
  background-color: #E8E8ED!important;
}
</style>
